var map = {
	"./bbc.png": 8458,
	"./disco.png": 9031,
	"./espn.png": 3007,
	"./fg.jpg": 4208,
	"./film.png": 9523,
	"./fubo.png": 7267,
	"./national.png": 6555,
	"./npo.png": 3292,
	"./par.png": 3080,
	"./prime.png": 8124,
	"./rtl.png": 439,
	"./sbs.png": 5575,
	"./sdc.png": 7313,
	"./sky.png": 9902,
	"./spi.png": 55,
	"./talpa.png": 1611,
	"./vrt.png": 1513,
	"./ziggo1.png": 5476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2117;